import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection, FullContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

import ProductTable from './items/product-table';

export default function TourProductCard() {
  const { t } = useTranslation();
  const name = 'approvalable.tourProducts';

  return (
    <CardSection>
      <Text variant="HeadingXSmall">
        {t('common:detail_extra', { extra: t('common:product') })}
      </Text>
      <HOCInput
        keys={[name]}
        children={(value) => {
          if (!value[name].length) return null;
          return (
            <FullContainer>
              <Separator gap={16} direction="vertical" />
              <ProductTable value={value} />
            </FullContainer>
          );
        }}
      />
    </CardSection>
  );
}
